"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentCookieDomain = exports.getCookieDomain = void 0;
var parse_domain_1 = __importDefault(require("parse-domain"));
function getCookieDomain(url) {
    var parseResult = parse_domain_1.default(url);
    var topDomain = '';
    if (parseResult) {
        var domain = parseResult.domain, tld = parseResult.tld;
        topDomain = "." + domain + "." + tld;
    }
    else {
        topDomain = url;
    }
    return topDomain;
}
exports.getCookieDomain = getCookieDomain;
function currentCookieDomain() {
    var hostname = location.hostname;
    var domain = getCookieDomain(hostname);
    return domain;
}
exports.currentCookieDomain = currentCookieDomain;
//# sourceMappingURL=url.js.map